export default "__VITE_ASSET__DnbXv5$___"